module.exports = __webpack_public_path__ + "static/img/website-logo.ceba2dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website-logo.png
// module id = pw1d
// module chunks = 0